import Iconify from 'src/components/Iconify';
import { fToNow } from 'src/utils/formatTime';

const AVATAR_COLORS = ['#7C3AED', '#2563EB', '#059669', '#D97706', '#DC2626', '#0891B2', '#DB2777'];

function getCorAvatar(nome) {
    if (!nome) return AVATAR_COLORS[0];
    let hash = 0;
    for (let i = 0; i < nome.length; i += 1) hash = nome.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getIniciais(nome) {
    if (!nome) return '?';
    return nome.trim().split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase();
}

const qualificacaoConfig = {
    1: { label: 'Sem interesse', color: '#9ca3af', icon: 'mdi:snowflake' },
    2: { label: 'Frio', color: '#3b82f6', icon: 'mdi:snowflake' },
    3: { label: 'Morno', color: '#f59e0b', icon: 'mdi:fire' },
    4: { label: 'Esquentando', color: '#f97316', icon: 'mdi:fire' },
    5: { label: 'Quente', color: '#ef4444', icon: 'mdi:fire' },
};

function formatCurrency(value) {
    return `R$ ${parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
}

export default function NegocioCard({ card, onOpen }) {
    const qualificacao = qualificacaoConfig[card?.qualificacao] || qualificacaoConfig[1];
    const nome = card?.nome || 'Sem nome';
    const contato = card?.contato?.nome || card?.nomeUsuario;
    const temFunil = card?.nomeFunil || card?.nomeEstagio;

    return (
        <div
            onClick={onOpen}
            className="bg-white dark:bg-[#222529] rounded-lg border border-gray-200/60 dark:border-[#383838] p-2 shadow-[0_1px_2px_rgba(16,24,40,0.06)] hover:shadow-[0_4px_10px_rgba(16,24,40,0.1)] hover:-translate-y-px transition-all duration-200 cursor-pointer group"
        >
            <div className="flex items-start gap-1.5">
                <span
                    className="w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-bold text-white flex-shrink-0"
                    style={{ backgroundColor: getCorAvatar(nome) }}
                >
                    {getIniciais(nome)}
                </span>

                <div className="min-w-0 flex-1">
                    <p className="text-xs font-semibold text-gray-900 dark:text-[#D1D2D3] leading-snug line-clamp-2">
                        {nome}
                    </p>
                    {(temFunil || contato) && (
                        <p className="text-[10px] leading-tight text-gray-500 dark:text-[#ABABAD] line-clamp-1 mt-0.5 flex items-center gap-1">
                            {temFunil ? (
                                <>
                                    <Iconify icon="ph:funnel-duotone" width={10} className="flex-shrink-0" />
                                    <span className="truncate">
                                        {[card?.nomeFunil, card?.nomeEstagio].filter(Boolean).join(' → ')}
                                    </span>
                                </>
                            ) : (
                                <>
                                    <Iconify icon="mdi:account-outline" width={10} className="flex-shrink-0" />
                                    <span className="truncate">{contato}</span>
                                </>
                            )}
                        </p>
                    )}
                </div>

                <button
                    type="button"
                    title="Abrir negócio"
                    onClick={(e) => { e.stopPropagation(); onOpen?.(); }}
                    className="w-5 h-5 rounded-md text-gray-300 hover:bg-gray-100 dark:hover:bg-[#383838] hover:text-[#7C3AED] flex items-center justify-center transition-all opacity-0 group-hover:opacity-100 flex-shrink-0"
                >
                    <Iconify icon="eva:edit-2-outline" width={12} />
                </button>
            </div>

            <div className="flex items-center justify-between gap-1 mt-1.5 pt-1.5 border-t border-gray-100 dark:border-[#383838]/60">
                <div className="flex items-center gap-1 min-w-0 flex-1">
                    <span
                        className="inline-flex items-center gap-0.5 max-w-full h-5 px-1.5 rounded-md text-[9px] font-semibold leading-none truncate"
                        style={{ color: qualificacao.color, backgroundColor: `${qualificacao.color}15` }}
                    >
                        <Iconify icon={qualificacao.icon} width={11} />
                        {qualificacao.label}
                    </span>
                    {card?.status && (
                        <span className="inline-flex items-center h-5 px-1.5 rounded-md text-[9px] font-semibold text-gray-500 dark:text-[#ABABAD] bg-gray-50 dark:bg-[#1A1D21] truncate">
                            {card.status}
                        </span>
                    )}
                </div>

                <div className="flex items-center gap-1 flex-shrink-0">
                    {card?.valor > 0 && (
                        <span className="flex items-center px-1 py-0.5 rounded bg-green-50 dark:bg-green-500/10 text-[9px] font-semibold text-green-700 dark:text-green-400 tabular-nums">
                            {formatCurrency(card.valor)}
                        </span>
                    )}
                    {card?.data_modificacao && (
                        <span className="text-[9px] text-gray-400 tabular-nums">
                            {fToNow(card.data_modificacao)}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}
